/**
 * functions/objects for visitor bubbles
 */
(function ($) {
    var dots = {};

    dots.DotsReplacement = {
        init: function (field, target, options) {
            this.field = jQuery(field); // parent object
            this.target = jQuery(target); // children element class
            this.gate = jQuery(window);
            this.alpha = true;
            this.redraw = false;

            this.options = $.extend({
                box_height: 40,
                box_width: 40,
                grid_element_width: 50,
                grid_element_height: 50
            }, options);

            this.target.hide();
        },
        placement: function () {
            this.alpha = true;
            var x = 0,
                y = 0,
                row = 0,
                range_x = this.options.grid_element_width - this.options.box_width + 10,
                range_y = this.options.grid_element_height - this.options.box_height + 10,
                max_width = this.field.width() - this.options.grid_element_width,
                that = this;

            this.target.each(function () {
                $(this).css({
                    left: x + Math.floor((Math.random() * range_x) + 1),
                    top: y + Math.floor((Math.random() * range_y) + 1)
                });

                if (x >= max_width / 2) {
                    $(this).removeClass("left-half").addClass("right-half");
                } else {
                    $(this).removeClass("right-half").addClass("left-half");
                }


                x += that.options.grid_element_width;

                if (x >= max_width) {
                    if (row % 2 === 0) {
                        x = Math.floor(that.options.grid_element_width / 2);
                    } else {
                        x = 0;
                    }
                    y += that.options.grid_element_height;
                    row++;
                }
            });
            y += that.options.grid_element_height;
            this.field.css("height", y);
            this.target.show();
        },
        start: function () {

            this.placement();
            var that = this;

            this.gate.resize(function () {
                if (that.alpha) {
                    that.alpha = false;
                    that.target.hide();
                }
                clearTimeout(that.redraw);
                that.redraw = setTimeout(function () {
                    that.placement();
                }, 500);
            });
        }
    };

    dots.DotsReplacementEliptic = {
        init: function (field, target, options) {
            this.field = jQuery(field); // parent object
            this.target = jQuery(target); // children element class
            this.gate = jQuery(window);
            this.alpha = true;
            this.redraw = false;
            this.width = this.field.width();
            this.height = 500;
            this.center = {x: 0.5, y: 0.5};
            this.data = {};
            this.data.angle = Math.random() * 6.28;
            this.data.step = 2.0;
            this.data.placed_words = [];

            this.options = $.extend({
                box_height: 40,
                box_width: 40,
                grid_element_width: 50,
                grid_element_height: 50,
                center: {
                    x: 0.5,
                    y: 0.5
                }
            }, options);

            // abschätzung der höhe
            var min_height = 300;
            var area = this.target.length * this.options.box_height * this.options.box_width;
            var factor = 3.5;
            var height = (area * factor) / this.width;
            if (height < min_height) {
                height = min_height;
            }
            this.height = height;
            this.data.aspect_ratio = this.width / this.height;


            this.field.height(this.height);
            this.target.hide();
        },
        // Pairwise overlap detection
        overlapping: function (a, b) {
            var width_1 = Math.abs(2.0 * a.left + this.options.box_width - 2.0 * b.left - this.options.box_width);
            var width_2 = this.options.box_width + this.options.box_width;
            var height_1 = Math.abs(2.0 * a.top + this.options.box_height - 2.0 * b.top - this.options.box_height);
            var height_2 = this.options.box_height + this.options.box_height;

            /*if (Math.abs(2.0*a.left + this.options.box_width - 2.0*b.left - this.options.box_width) < this.options.box_width + this.options.box_width) {
             if (Math.abs(2.0*a.top + this.options.box_height - 2.0*b.top - this.options.box_height) < this.options.box_height + this.options.box_height) {
             return true;
             }
             }*/

            if (width_1 < width_2) {
                if (height_1 < height_2) {
                    return true;
                }
            }

            return false;
        },

        // Helper function to test if an element overlaps others
        hitTest: function (elem) {
            // Check elements for overlap one by one, stop and return false as soon as an overlap is found
            for (var i = 0, l = this.data.placed_words.length; i < l; i++) {
                if (this.overlapping(elem, this.data.placed_words[i])) {
                    return true;
                }
            }
            return false;
        },
        placement: function () {
            var that = this;
            this.target.each(function (index) {
                that.drawOne(index, $(this));
            });
            this.target.show();
        },
        // Function to draw a word, by moving it in spiral until it finds a suitable empty place
        drawOne: function (index, elem) {

            // option.shape == 'elliptic'
            var angle = this.data.angle,
                radius = 0.0,

                word_size = {};
            word_size.left = this.options.center.x * this.width - this.options.box_width / 2.0;
            word_size.top = this.options.center.y * this.height - this.options.box_height / 2.0;

            // Save a reference to the style property, for better performance
            word_style = elem[0].style;
            word_style.position = 'absolute';
            word_style.left = word_size.left + 'px';
            word_style.top = word_size.top + 'px';

            while (this.hitTest(word_size)) {
                var tmp_step = this.data.step + (Math.random() * 4 - 2);
                // Default settings: elliptic spiral shape
                radius += tmp_step;
                angle += (index % 2 === 0 ? 1 : -1) * tmp_step;

                word_size.left = this.options.center.x * this.width - (this.options.box_width / 2.0) + (radius * Math.cos(angle)) * this.data.aspect_ratio;
                word_size.top = this.options.center.y * this.height + radius * Math.sin(angle) - (this.options.box_height / 2.0);

            }

            word_style.opacity = Math.max(0, 1 - Math.pow((index / 150), 5));
            word_style.left = word_size.left + 'px';
            word_style.top = word_size.top + 'px';

            // Don't render word if part of it would be outside the container
            if (
                word_size.left < 0 || word_size.top < 0 ||
                (word_size.left + word_size.width) > this.width ||
                (word_size.top + word_size.height) > this.height
            ) {
                elem.hide();
                return;
            }

            // Save position for further usage
            this.data.placed_words.push(word_size);

            /*if (typeof word.afterWordRender === 'function') {
             word.afterWordRender.call(word_span);
             }*/
        },
        start: function () {

            this.placement();
            var that = this;

            this.gate.resize(function () {
                if (that.alpha) {
                    that.alpha = false;
                    that.target.hide();
                }
                clearTimeout(that.redraw);
                that.redraw = setTimeout(function () {
                    that.data.placed_words = [];
                    that.width = that.field.width();

                    // abschätzung der höhe
                    var min_height = 300;
                    var area = that.target.length * that.options.box_height * that.options.box_width;
                    var factor = 3;
                    var height = (area * factor) / that.width;
                    if (height < min_height) {
                        height = min_height;
                    }
                    that.height = height;
                    that.data.aspect_ratio = that.width / that.height;


                    that.field.height(that.height);
                    that.placement();
                }, 500);
            });
        }
    };

    dots.Dots = {
        init: function (field, target, options) {
            this.field = jQuery(field); // parent object
            this.target = jQuery(target); // children element class
            this.order = jQuery('#grouped'); // this button will give the elements structure
            this.random = jQuery('#erratic'); // click this object to shuffle
            this.words = jQuery('.formation'); // selector class of button inline text

            this.options = $.extend({
                limit: 40, // distance randomised elements will stay away from parent's edge
                mount: 20, // extra space (similar to margin) added around each random element
                initial: 8, // number of elements to initially place inside quadrants
                ensued: false, // set to true will start page with aligned elements
                expand: {} // margins for organised layout will be copied from stylesheet
            }, options);

            this.target.hide();
            this.readMargin();

            //this.start();
        },
        start: function () {
            this.field.width('100%');
            this.gate = jQuery(window);
            this.spread = this.field.width();
            this.occupied = jQuery('body').height();
            this.term = this.gate.height() - this.occupied;
            this.crest = this.alpha = this.redraw = this.total = 0;
            this.minimum = this.dynamic = this.boxes = [];
            this.profuse = false;

            this.surfaceArea();
            this.initiateScene();

            var that = this;

            this.gate.resize(function () {

                if (that.alpha) {
                    that.alpha = false;
                    that.target.add(that.words).hide();
                    that.field.height(0);
                }
                that.spread = that.field.width();
                that.term = that.gate.height() - that.occupied;
                clearTimeout(that.redraw);
                that.redraw = setTimeout(function () {
                    that.initiateScene(that.options);
                }, 1000);
            });
        },

        surfaceArea: function () {

            var that = this, range, wide = 0, pitch;
            this.target.each(function () {
                range = jQuery(this).width() + 2 * that.options.mount;
                if (range > wide) {
                    wide = range;
                }
                pitch = jQuery(this).height() + 2 * that.options.mount;
                that.total += range * pitch;
            });
            this.minimum = 3 * wide + 2 * this.options.limit;
        },

        initiateScene: function (_options) {
            var options = (_options) ? _options : this.options;

            this.alpha = true;
            if (options.ensued) {
                this.target.css('display', 'inline-block');
            } else {
                if (this.spread >= this.minimum) {
                    if (!this.dynamic) {
                        this.target.css({position: 'absolute', margin: 0});
                        this.dynamic = true;
                    }
                    var edge = 2.5 * this.total / (this.spread - 2 * options.limit) + 2 * options.limit;
                    if (this.term < edge) {
                        this.crest = edge;
                    } else {
                        this.crest = this.term;
                    }
                    this.field.css({height: this.crest});
                }
            }
            this.spread = this.field.width();
            if (this.spread >= this.minimum) {
                this.profuse = true;
                if (!this.ensued) {
                    this.placeRandom();
                }
                this.words.show();
            }
            else {
                this.profuse = false;
                this.normalFlow();
            }
        },

        normalFlow: function () {

            if (!this.options.ensued) {
                this.field.height(0);
                this.target.css({
                    position: 'relative',
                    top: 0,
                    left: 0,
                    display: 'inline-block',
                    margin: this.options.expand
                });
                this.ensued = true;
                this.dynamic = false;
            }
        },

        placeRandom: function () {

            this.boxes.length = 0;
            this.iter = 0;
            this.box = {};
            this.horizontal = this.spread / 2;
            this.vertical = this.crest / 2;

            var that = this;

            this.target.each(function () {
                that.iter++;
                var object = $(this);
                that.setPosition(object);
                that.boxes.push(that.box);
                object.show();
            });
        },

        setPosition: function (object) {
            var zone = Math.round(object.width()),
                unit = Math.round(object.height());

            if (this.iter <= this.options.initial) {

                var quadrant = this.iter % 4;
                if (quadrant === 0) {
                    quadrant = 4;
                }
                var spaceX = Math.round(Math.random() * (this.horizontal - zone - this.options.limit)),
                    spaceY = Math.round(Math.random() * (this.vertical - unit - this.options.limit)),
                    bufferX, bufferY;

                if (quadrant === 1) {
                    bufferX = this.options.limit;
                    bufferY = this.options.limit;
                }
                if (quadrant === 2) {
                    bufferX = this.horizontal;
                    bufferY = this.options.limit;
                }
                if (quadrant === 3) {
                    bufferX = this.horizontal;
                    bufferY = this.vertical;
                }
                if (quadrant === 4) {
                    bufferX = this.options.limit;
                    bufferY = this.vertical;
                }
                this.fixleft = spaceX + bufferX;
                this.fixtop = spaceY + bufferY;
            }
            else {
                this.fixleft = Math.round(Math.random() * (this.spread - zone - 2 * this.options.limit)) + this.options.limit;
                this.fixtop = Math.round(Math.random() * (this.crest - unit - 2 * this.options.limit)) + this.options.limit;
            }

            object.css({top: this.fixtop, left: this.fixleft});
            this.box = {top: this.fixtop, left: this.fixleft, width: zone, height: unit};

            if (this.iter === 1) {
                this.boxes.push(this.box);
            } else {
                for (var i = 0; i < this.boxes.length; i++) {
                    if (this.encroachOn(this.box, this.boxes[i])) {
                        this.setPosition(object);
                    }
                }
            }
        },
        encroachOn: function (box1, box2) {

            var x1 = box1.left,
                y1 = box1.top,
                h1 = box1.height,
                w1 = box1.width,
                b1 = y1 + h1,
                r1 = x1 + w1,
                x2 = box2.left,
                y2 = box2.top,
                h2 = box2.height,
                w2 = box2.width,
                b2 = y2 + h2,
                r2 = x2 + w2,

                apex = b1 + this.options.mount > y2 - this.options.mount,
                nadir = y1 - this.options.mount < b2 + this.options.mount,
                sin = r1 + this.options.mount > x2 - this.options.mount,
                dex = x1 - this.options.mount < r2 + this.options.mount;

            return (apex && nadir && sin && dex);
        },

        readMargin: function () {

            var t = this.target.css('margin-top'),
                r = this.target.css('margin-right'),
                b = this.target.css('margin-bottom'),
                l = this.target.css('margin-left'),

                all = [t, r, b, l];
            this.options.expand = all.toString().replace(/,/g, " ");
        }
    };

    dots.ExpertDots = {
        init: function (fields, target) {
            this.fields = $(fields); // parent object
            this.target = target; // children element class

            this.fields.parent().addClass('animated');
            this.fields.find('.dot').hover(function () {
                $(this).animate({'background-size': 'auto 200%'}, 3000);
            }, function () {
                $(this).animate({'background-size': 'auto 100%'}, 3000);
            });

            var that = this;
            $(window).resize(function () {
                if (parseInt($(window).width()) < 481) {
                    return false;
                }
                clearTimeout(that.redraw);
                that.redraw = setTimeout(function () {
                    that.setPosition();
                }, 1000);
            });

            this.setPosition();
        },
        setPosition: function () {
            var that = this,
                window_width = parseInt($(window).width()),
                key = 'expertDot_' + window_width,
                coords = [],
                saved_coords;// = Cookies.get(key);

            this.fields.each(function (index, item) {
                var boundary = $(item),
                    target = boundary.find(that.target);

                if (saved_coords && saved_coords[index]) {
                    current_coords = saved_coords[index];
                } else {
                    var maxX = boundary.width() - target.width(),
                        maxY = boundary.height() - target.height();

                    current_coords = {
                        x: Math.round(Math.random() * maxX),
                        y: Math.round(Math.random() * maxY)
                    };
                    coords[index] = current_coords;
                }

                target.css({transform: 'translate3d(' + current_coords.x + 'px, ' + current_coords.y + 'px, 0)'});
            });

            //Cookies.set(key, coords);
        }
    };

    dots.DotsUserQuestions = {
      isInit: false,

      // update elements with vote change
      update: function(elements) {
        this.updateMaxVoteCount(elements);

        this.target = this.field.find(this.targetSelector);
        this.data.placed_words_new = [];
        var that = this;

        var checksize = [];

        // loop over all elements
        this.target.each(function(index){

          var votecount = $(this).attr("data-votecount");
          var width = Math.round(parseFloat($(this).width()));
          var left = $(this).css("left");
          var top = $(this).css("top");

          // ignore new unpositioned elements
          if(left !== "auto" && top !== "auto" && votecount) {
            left = parseFloat(left);
            top = parseFloat(top);

            var left_center = left + width/2.0;
            var top_center = top + width/2.0;

            var new_radius = Math.round(that.minRadius + that.voteFactor * votecount); // 20px + factor per vote * 30px
            var new_width = new_radius * 2; // 20px + factor per vote * 30px
            var new_left = (left_center - new_radius) + 2; // +2 for rounding errors
            var new_top = (top_center - new_radius) + 2;

            if(new_left < 0) {
              new_left = 0;
            }
            if(new_top < 0) {
              new_top = 0;
            }
            if(new_left + new_width > that.width) {
              new_left = that.width - new_width;
            }
            if(new_top + new_width > that.height) {
              new_top = that.height - new_width;
            }

            // something changed?
            if(new_width !== width &&
              new_left !== left &&
              new_top !== top
            ) {
              $(this).stop().animate({
                width: new_width,
                height: new_width,
                left: new_left,
                top: new_top
              });

              word_size = {};
              word_size.element = $(this);
              word_size.radius = new_radius;
              word_size.left = new_left;
              word_size.top = new_top;

              that.data.placed_words_new.push(word_size);
            }
          }
        });
          // hittest and reposition
        //console.log(that.data.placed_words_new);
      },

      updateCache: function() {
        this.data.placed_words = [];
        var that = this;
        this.target.each(function (index) {

          var radius = Math.round(parseFloat($(this).width()) / 2);
          var left = $(this).css("left");
          var top = $(this).css("top");
          if (left !== "auto" && top !== "auto") {
            left = parseFloat(left);
            top = parseFloat(top);
          }

          word_size = {};
          word_size.element = $(this);
          word_size.radius = radius;
          word_size.left = left;
          word_size.top = top;

          that.data.placed_words.push(word_size);
        });
      },

      add: function(elements) {
        var that = this;
        this.target = this.field.find(this.targetSelector);
        this.updateHeight();

        elements.each(function (index) {
          that.drawOne(index, $(this));
        });
        //elements.css("opacity",0);
        elements.show();
        //elements.fadeIn();
      },

      updateMaxVoteCount: function(elements) {
        var that = this;
        this.maxVoteCount = 10; // 10 = min value
        elements.each(function (index) {
          var votecount = parseInt($(this).attr("data-votecount"));
          if(votecount) {
            that.maxVoteCount = Math.max(that.maxVoteCount, votecount);
          }
        });
        this.voteFactor = ((this.maxRadius - this.minRadius) ) / this.maxVoteCount; // factor per vote, range from 20 to 50

      },

      updateHeight: function(){
        // abschätzung der höhe
        var min_height = 600;
        var area = this.target.length * Math.pow(this.minRadius + this.maxRadius,2);
        var height = (area * this.heightFactor) / this.width;
        if (height < min_height) {
          height = min_height;
        }
        this.height = height;
        this.data.aspect_ratio = this.width / this.height;

        this.field.height(this.height);
      },

      init: function (field, target, options) {
        this.field = jQuery(field); // parent object
        this.targetSelector = target;
        this.target = this.field.find(this.targetSelector); // children element class
        this.gate = jQuery(window);
        this.alpha = true;
        this.redraw = false;
        this.width = this.field.width();
        this.height = 500;
        this.center = {x: 0.5, y: 0.5};
        this.data = {};
        this.data.placed_words = [];
        this.data.placed_words_new = [];
        this.minRadius = 20;
        this.maxRadius = 50;
        this.spaceBetween = 30;
        this.maxVoteCount = 10;
        this.heightFactor = 4;
        this.voteFactor = 1; // factor per vote

        this.updateMaxVoteCount(this.target);
        this.updateHeight();

        this.options = $.extend({
          center: {
            x: 0.5,
            y: 0.5
          }
        }, options);


        this.target.hide();
      },
      // Pairwise overlap detection
      overlapping: function (a, b) {


        var minDist = a.radius + b.radius + this.spaceBetween;

        var dist_x = Math.abs( (a.left + a.radius) - (b.left + b.radius));
        var dist_y = Math.abs( (a.top + a.radius) - (b.top + b.radius));

        var dist = Math.sqrt(dist_x * dist_x + dist_y * dist_y);

        return dist < minDist;
      },

      // Helper function to test if an element overlaps others
      hitTest: function (elem) {
        // Check elements for overlap one by one, stop and return false as soon as an overlap is found
        for (var i = 0, l = this.data.placed_words.length; i < l; i++) {
          if (this.overlapping(elem, this.data.placed_words[i])) {
            return true;
          }
        }
        return false;
      },
      placement: function () {
        var that = this;
        this.target.each(function (index) {
          that.drawOne(index, $(this));
        });
        this.target.show();
      },
      // Function to draw a word, by moving it in spiral until it finds a suitable empty place
      drawOne: function (index, elem) {

        // calc width based on votes
        var votecount = parseInt($(elem).attr("data-votecount"));
        var new_width;
        var new_radius;

        if(votecount) {
          new_radius = Math.round(this.minRadius + this.voteFactor * votecount); // 20px + factor per vote * 30px
          new_width = new_radius * 2;

          elem.css({
            width: new_width,
            height: new_width
          });
        } else {
          new_radius = this.minRadius;
        }

        word_size = {};
        word_size.element = elem;
        word_size.radius = new_radius;
        word_size.left = Math.floor((Math.random() * (this.width - 4 * word_size.radius)) + word_size.radius);
        word_size.top = Math.floor((Math.random() * (this.height - 4 * word_size.radius)) + word_size.radius);

        var counter = 0;
        while (this.hitTest(word_size)) {
          if(counter > 100) {
            console.log("error on:");
            console.log(word_size);
            break;
          }
          word_size.left = Math.floor((Math.random() * (this.width - 4 * word_size.radius)) + word_size.radius);
          word_size.top = Math.floor((Math.random() * (this.height - 4 * word_size.radius)) + word_size.radius);
          counter++;
        }

        // Save a reference to the style property, for better performance
        word_style = elem[0].style;
        word_style.position = 'absolute';
        word_style.left = word_size.left + 'px';
        word_style.top = word_size.top + 'px';

        // Save position for further usage
        this.data.placed_words.push(word_size);

        /*if (typeof word.afterWordRender === 'function') {
         word.afterWordRender.call(word_span);
         }*/
      },
      start: function () {

        this.placement();
        var that = this;
/*
        this.gate.resize(function () {
          if (that.alpha) {
            that.alpha = false;
            that.target.hide();
          }
          clearTimeout(that.redraw);
          that.redraw = setTimeout(function () {
            that.data.placed_words = [];
            that.width = that.field.width();

            // abschätzung der höhe
            var min_height = 300;
            var area = that.target.length * that.options.box_height * that.options.box_width;
            var factor = 3;
            var height = (area * factor) / that.width;
            if (height < min_height) {
              height = min_height;
            }
            that.height = height;
            that.data.aspect_ratio = that.width / that.height;


            that.field.height(that.height);
            that.placement();
          }, 500);
        }); */
      }
    };

    window.vrnetworld.dots = dots;
})(jQuery); // Fully reference jQuery after this point.
